module.exports = __webpack_public_path__ + "static/media/logo_opa.efe8d6a0.png";